module.exports = __webpack_public_path__ + "static/media/add-bold.ee5d757d.svg";